import { render, staticRenderFns } from "./AreaCliente.vue?vue&type=template&id=6d7e6445"
import script from "./AreaCliente.vue?vue&type=script&lang=js"
export * from "./AreaCliente.vue?vue&type=script&lang=js"
import style0 from "./AreaCliente.vue?vue&type=style&index=0&id=6d7e6445&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports